import React from 'react';

const UpdateCustomFieldsContext = React.createContext({
  isDownloadingTemplate: false,
  setIsDownloadingTemplate: function() {}
});

export const UpdateCustomFieldsProvider = UpdateCustomFieldsContext.Provider;
export default UpdateCustomFieldsContext;
